import alert from './assets/alert.webp';
import checkMark from './assets/checkMark.webp';
import doggo from './assets/doggo.webp';
import hamsterCry from './assets/hamster-cry.webp';
import handMobile from './assets/handMobile.webp';
import handMobileAndCross from './assets/handMobileAndCross.webp';
import partnersLogo from './assets/partnersLogo.webp';
import partnersLogoWhite from './assets/partnersLogoWhite.webp';
import thumbsDown from './assets/thumbsDown.webp';
import thumbsUp from './assets/thumbsUp.webp';
import timeOut from './assets/timeOut.webp';
export const illustrationMap = {
    thumbsUp,
    thumbsDown,
    alert,
    handMobileAndCross,
    timeOut,
    checkMark,
    hamsterCry,
    partnersLogo,
    partnersLogoWhite,
    handMobile,
    doggo,
};
